<template>

  <div class="font-proxima" v-if="pricingData">

    <header  class="psn-gradient-header text-center text-white flex flex-col space-y-4 md:space-y-8 pt-16 px-2">

      <h1 class="text-4xl text-center font-semibold" style="width:50%; margin:0 auto;">{{pricingData.header}}</h1>
      <p class="font-georgia " style="font-size: 18px; color: #F7F8FA;">We make it easy to get the documents you need. Guaranteed.</p>

    </header>
    <section class="container bg-white" style="width:80%; margin:0 auto;">
      <!-- Prices form  -->
      <div :class="pricingTableCls" >

        <div v-for="(product, index) of pricingData.products" :key="product.title"
          :class="index % 2 ? 'form gray' : 'form'" >

          <h2 class="form_head green">{{product.title}}</h2>
          <div class="form_info font-georgia">{{product.desc}}</div>

          <div class="form_digital_price">
            <p class="price_title green">DIGITAL</p>
            <p class="price font-georgia green">{{product.digital.price}}</p>
            <p class="flex gap-4 items-start ">
              <span class="pdf-bg pricing-icon"></span>
              <span class="details py-0"> Printable PDF sent instantly by email</span>
            </p>
          </div>

          <!-- <div class="form_phisical_price">
            <p class="price_title green">PHYSICAL</p>

            <template v-if="product.physical">
              <p class="price font-georgia green">{{product.physical.price}}</p>

              <p class="flex gap-4 items-start mb-5">
                <span class="printer-bg pricing-icon"></span>
                <span class="details py-0"> Printed on authentic payroll paper</span>
              </p>
              <p class="flex gap-2 items-start ">
                <span class="delivery-bg pricing-icon"></span>
                <span class="details py-0"> Shipped to your door in 2-4 business days with a tracking number.</span>
              </p>
            </template>

            <p class="price font-georgia" v-else>N/A</p>
          </div> -->

          <router-link :to="{name: product.route}" :style="'background-color:' + product.action.bg"
            class="flex gap-5 justify-center items-center">{{product.action.text}}
              <span class="right-arrow-bg"></span>
            </router-link>
        </div>
      </div>

      <!-- Hundreds of satisfied customers... -->
      <div class="green feathers mt-12 pt-12 mb-12">
        <h2 class="text-center text-5xl w-4/5" style="margin:52px auto;">Hundreds of satisfied customers trust their important documents to The Best Paystubs</h2>
        <div class="lg:flex justify-between text-2xl gap-16">
          <div class="leading-10">
            <ul class="benefits-list">
              <li>
                {{country !== 'ca'
                  ? 'Built by accounting professionals'
                  : 'Built and verified by certified Canadian accounting professionals'
                }}
              </li>
              <li>Accurate form calculations</li>
              <li>Easy-to-follow online process</li>
              <li>{{authority}}-quality documents</li>
            </ul>
          </div>
          <div class="leading-10">
            <ul class="benefits-list">
              <li>Instant digital delivery</li>
              <!-- <li v-if="country === 'us'">Fast shipping</li> -->
              <li>24/7 support by email or chat</li>
              <li>Money back guarantee</li>
              <!-- <li>Option to create a free profile to save your documents</li> -->
            </ul>
          </div>
        </div>
      </div>

      <!-- Slider for desktop-->
      <div class="relativ carousel mt-12 pt-12 hidden lg:block">
        <div class="carousel_head text-center">
          <h2 class="green text-5xl">Customers trust our check stub maker.</h2>
          <p class="content-italic-subheader">They really do.</p>
        </div>

          <swiper
            :slidesPerView="2"
            :spaceBetween="30"
            :pagination="{
              clickable: true,
            }"
            :modules="modules"
            class="mySwiper"
          >
            <swiper-slide v-for="(t, i) of testimonials" :class="!i ? 'mx-auto' : ''" :key="t.name" >
              <div class="card">
                <div class="img">
                  <div class="circle">
                    <img :src="t.pic" :alt="'Picture of ' + t.name">
                  </div>
                  <div class="quote-bg"></div>
                </div>
                <p>{{t.p}}</p>
                <span>— {{t.name}}</span>
              </div>
            </swiper-slide>

          </swiper>
      </div>

      <!-- Slider for smaller screens -->
      <div class="relativ carousel mt-12 pt-12  lg:hidden">
        <div class="carousel_head text-center">
          <h2 class="green text-5xl">Customers trust our check stub maker.</h2>
          <p class="content-italic-subheader">They really do.</p>
        </div>

        <swiper
            :slidesPerView="1"
            :spaceBetween="30"
            :pagination="{
              clickable: true,
            }"
            :modules="modules"
            class="mySwiper"
          >
          <swiper-slide v-for="(t, i) of testimonials" :class="!i ? 'mx-auto' : ''" :key="t.name" >
              <div class="card">
                <div class="img">
                  <div class="circle">
                    <img :src="t.pic" :alt="'Picture of ' + t.name">
                  </div>
                  <div class="quote-bg"></div>
                </div>
                <p>{{t.p}}</p>
                <span>— {{t.name}}</span>
              </div>
          </swiper-slide>
        </swiper>
      </div>

      <!-- Mini FAQ -->
      <FAQVue :faq-data="faqData" ></FAQVue>
    </section>

  </div>

</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import FAQVue from './FAQ.vue';
import pageData from "@/lib/page-data";
import cachedPrices from "@/lib/pricing-data.js";

export default {
  components:{
    FAQVue,
    Swiper,
    SwiperSlide,
  },

  data () {
    return {
      pricingData: null,
    }
  },

  setup() {
    return {
      modules: [Pagination],
    };
  },


  computed: {
    country () {
      return this.$route.meta.country;
    },

    pricingTableCls () {
      let ret = 'grid md:grid-cols-2 form_container ';
      ret += this.pricingData.products.length > 2 ? 'lg:grid-cols-3' : 'lg:grid-cols-2';
      return ret;
    },

    authority () {
      const auth = {
        us: "IRS",
        ca: "CRA",
        uk: "HMRC",
      };
      return auth[this.country];
    },

    products () {
      return this.$root.products;
    },

    faqData () {
      return [
        {
          q: `Will banks and government institutions accept these documents?`,
          a: [`Yes! You can rest assured that our payroll documents are created using the most recent
          ${this.country === 'ca' ? 'federal and provincial' : 'state and local'}
          calculations and are ${this.authority} compliant.
          We even provide the formulas directly within each form for your reference.
          The Best Paystubs is regularly reviewed and vetted by professional accountants for your peace of mind.`]
        },
        {
          q: `What if I make a mistake?`,
          a: [`No problem! You’ll have an opportunity to review your paystubs,
          ${ this.country === 'us' ? 'W-2, 1099s' : 'T4 slips' } and invoices
          for accuracy before you buy and can edit with ease.
          If you notice an error once you’ve made your purchase, please reach out to our customer support team for assistance.`]
        },
        {
          q: `Where do I go for help when completing a form?`,
          a: [`Our forms contain easy-to-follow instructions.
          If you have questions at any point in the process, our fast and friendly customer
          support team is available 24/7 by email or chat. `]
        },
        {
          q: `I’ve seen free paystub generators online. Why should I pay for your service?`,
          a: [`Whether you’re creating paystubs for yourself or for your employees, reliability is important.
            Unlike free paystub generators, The Best Paystubs is the only online paystub generator
            that features auto-calculation for every ${ this.country === 'us' ? 'state' : 'province' }
            — so you know you’re getting the most accurate,
            complete paystubs and payroll documents on the market.`,

            `Our money-back guarantee, 24/7 customer support and professional templates are just a few more reasons
             we have the highest customer satisfaction rating.`]
        }
      ]
    },

    //select specific 2 that is requested by Vlad.
    testimonials () {
      return pageData.home.testimonials.slice(2, 4);
    },
  },

  watch: {
    country: {
      async handler () {
        //Original working code which dynamically fetchs products list.
        //const res = await this.$get("/api/products/list");
        //const products = res.data[country];

        //New code which uses static cached data:
        const products = cachedPrices[this.country];

        //match client data with what server has returned:
        let pricingData;

        switch (this.country) {
          case "us": {
            const { default: data } = await import("@/views/us/pricing-data.js");
            pricingData = data;
            break;
          }
          case "ca": {
            const { default: data } = await import("@/views/ca/pricing-data.js");
            pricingData = data;
            break;
          }
          case "uk": {
            const { default: data } = await import("@/views/uk/pricing-data.js");
            pricingData = data;
            break;
          }
        }

        pricingData.products.forEach(productGroup => {
          //find the mapping data from the server:
          ["digital", "physical"].forEach(edition => {
            if (! productGroup[edition]) return;
            const product = products.find(product => product.type === productGroup.serverType && product.edition === edition);
            if (! product) return;
            productGroup[edition].price = product.currency_sign + product.price;
          });
        });

        this.pricingData = pricingData;

      }, immediate: true,
    }
  }
}
</script>

<style scoped>

.pricing-icon {
  @apply bg-no-repeat bg-center p-3 pt-6 bg-contain;
}

.pdf-bg {
  background-image: url('@/assets/images/pdf.svg');
  @apply w-6 h-6 ;
}

.delivery-bg {
  background-image: url('@/assets/images/delivery.svg');
  @apply w-8 h-8 md:w-9 md:h-9 mr-0.5 ;
}

.printer-bg {
  background-image: url('@/assets/images/printer.svg');
  @apply w-6 h-6 ;
}

.right-arrow-bg {
  background-image: url('@/assets/images/right-arrow.svg');
  @apply bg-no-repeat bg-center w-6 h-4;
}

.benefits-list li {
  background-image: url('@/assets/images/check-mark.svg');
  @apply bg-no-repeat bg-contain pl-8 pt-0;
  background-position: 0 12px;
  background-size: 18px;
}

.quote-bg {
  background-image: url('@/assets/images/quote2.svg');
  @apply h-16 w-16 lg:h-10 lg:w-10 bg-no-repeat bg-contain bg-center;
}

.font-georgia{
  font-style: italic;
  color: #5E5E6C;
}
.green{
  color:#0B4652 !important;
  font-weight: 600;

}
.carousel{
  margin: 40px 0 100px ;
}

.swiper {
  height: auto;
  width: 100%;
  padding-top: 160px;
  padding-bottom: 100px;
}

:deep(.swiper-pagination-bullet-active)  {
  background-color: #00C0A2 !important;
}
:deep(.swiper-pagination-bullet){
  height: 20px;
  width: 20px;
}
.swiper-slide {
  height: 100%;
  width: 100%;
  text-align: center;
  font-size: 18px;
  background: #fff;
    display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.psn-gradient-header{
  height: auto !important;
  padding-bottom: 160px ;
}

.container{
  position: relative;
  top: -134px;
}

.form_container{
  box-shadow: 0px 0px 17px -5px #000000;
}

.form{
  position: relative;
  padding-bottom: 140px;
}


.form div{
  padding: 36px;
  color: #5E5E6C;
}

.gray{
  background: rgb(247, 247, 247)
}

.tbp-pricing-desc p {
  @apply mb-4;
}
.card{
  width: 100%;
  height: 317px;
  box-shadow: 0px 0px 17px -5px #000000;
  margin: 10px;
  padding: 41px;
  font-size: 20px;
  text-align: right;
  color: #5E5E6C;
  position: relative;
  padding-top:125px ;

}
.card p{
  text-align: left;
}

.img{
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: -135px;
  }
.circle{
  border-radius: 249px;
  width: 249px !important;
  height: 249px !important;
  overflow: hidden;
}

.form_head {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 134px;
  font-size: 34px;
  text-align: center;
  border-bottom: 1px solid #EEEEEE;
}

.form_info{
  font-size: 18px;
  min-height: 160px;
}

.price{
  font-size: 40px;
  margin-bottom: 10px;
}

.form_phisical_price{
  min-height: 260px;
}
.form button, .form a{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  font-size: 20px;
  @apply font-semibold;
  padding: 40px;
  text-align: center;
  color: white;
}
@media only screen and (max-width: 1440px) {
  .card{
    height: 360px;
  }
  .img{
    position: absolute;
    display: flex;
    align-items: flex-end;
    top: -100px;
    }
  .circle{
    border-radius: 249px;
    width: 160px !important;
    height: 160px !important;
    overflow: hidden;
  }
}
@media only screen and (max-width: 1390px) {
  .form_info{
    min-height: 260px;

  }
}
@media only screen and (max-width:1220px) {
  .card{
    height: 390px;
  }
}
@media only screen and (max-width: 1144px) {
  .form_info{
    min-height: 360px;

  }
  .card{
    height: 410px;
  }
}
@media only screen and (max-width:1220px) {
  .card{
    height: 390px;
  }
}
@media only screen and (max-width: 1144px) {
  .form_info{
    min-height: 360px;

  }
  .card{
    height: 410px;
  }
}
@media only screen and (max-width: 1023px) {
  .form_info{
    min-height: 200px;
  }
  .card{
    height: auto;
  }
  .img{
    position: absolute;
    display: flex;
    align-items: flex-end;
    top: -135px;
    }
  .circle{
    border-radius: 249px;
    width: 249px !important;
    height: 249px !important;
    overflow: hidden;
  }
}
@media only screen and (max-width: 700px) {
  .form_info{
    min-height: 160px;
  }
  .feathers h3,
  .carousel_head h3,
  .psn-gradient-header h1{
    font-size: 30px;
  }
  .feathers p,
  .carousel_head p,
  .psn-gradient-header p{
    font-size: 18px;
  }
  .card p{
    font-size: 16px;
  }
  .container{
    width: 100% !important;
  }
  .feathers{
    padding: 18px;
  }

  .container *{
    text-align: center;
  }
  .card{
    text-align: right !important;
  }
  .text-right{
    text-align: right !important;
  }
  .details,
  .feathers p{
    text-align: left;
  }

}
@media only screen and (max-width: 375px) {
  .img{
    position: absolute;
    display: flex;
    align-items: flex-end;
    top: -100px;
    }
  .circle{
    border-radius: 249px;
    width: 160px !important;
    height: 160px !important;
    overflow: hidden;
  }
}
</style>